 <template>
  <div class="payment-container">
    <nav class="add-navigation d-lg-flex justify-content-between w-100">
      <div class="search-container d-sm-flex justify-content-sm-start w-100">
        <div class="right-wrapprr">
          <search-input
            class="search-input"
            type="text"
            v-model="Searched"
            placeholder="Search for payment"
          />
        </div>
        <div class="show-active-items ml-sm-4 my-4 my-sm-0">
          <input
            type="checkbox"
            id="show-active"
            class="active-checkbox"
            v-model="isActive"
          />
          <label for="show-active">Active Only</label>
        </div>
      </div>
      <div class="buttons-wrapper top-nav">
        <div class="primary-button">
          <primary-button
            @click.native="
              $router.push({ name: 'system-admin-add-payment-term' })
            "
            >Add Payment Term</primary-button
          >
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <div
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table" v-if="!isShow">
          <thead>
            <tr class="Invoice_table_header">
              <th>Name</th>
              <th>Payment Cycle</th>
              <th>Grace Period</th>
              <th>Used BY</th>
              <th>Notify Days</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr class="line" v-for="(payment, k) in payments" :key="k">
              <th>
                <div class="d-flex align-items-center">
                  <span :title="payment.isActive ? 'Active' : 'Inactive'"
                          class="status d-block mx-2"
                          :class="payment.isActive ? 'active' : 'inactive'"
                          @click="changeStatus(payment.paymentTermId, payment.isActive)"
                  ></span>
                  <span>
                  {{ payment.name }}
                </span>
                </div>
              </th>
              <th>{{ payment.type }}</th>
              <th>{{ payment.graceDays }}</th>
              <th
                class="usedBy"
                @click="
                  $router.push({
                    name: 'system-admin-payment-term-companies',
                    params: { id: payment.paymentTermId },
                  })
                "
              >
                {{ payment.usedBy }}
              </th>
              <th>{{ payment.notifyDays }}</th>
              <th class="icon action">
                <svg
                  @click="
                    $router.push({
                      name: 'system-admin-edit-payment-term',
                      params: { id: payment.paymentTermId },
                    })
                  "
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <title>Edit</title>
                  <path
                    d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="deletePayment(payment.paymentTermId)"
                  class="svg-grey delete"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <title>Delete</title>
                  <path
                    d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                    id="path-1"
                  />
                </svg>
              </th>
            </tr>
          </tbody>
        </table>
        <div v-if="isShow" class="no-data-found">No Data Found</div>
      </div>
      <div :style="{ display: paginationCondition ? 'flex' : 'block' }">
        <div class="per-page">
          <span class="filter_by custom-row">Show Per Page:</span>
          <div class="primary-input-container choose-type perPage">
            <primary-select
              type="text"
              @input="changePerPage"
              v-model="per_page" :is-cross="false"
              class="choose-type perPage"
              placeholder="Select"
            >
              <option :value="item" v-for="(item, key) in pages" :key="key">
                {{ item }}
              </option>
            </primary-select>
          </div>
        </div>
        <div
          class="buttons-wrapper"
          :class="{ pagination: paginationCondition }"
        >
          <pagination-component
            @change-page="changePage($event)"
            :page="Page"
            :total="TotalPages"
            :perPage="per_page"
            :qnt="payments.length"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    type: [
      "Every",
      "Day of Month",
      "Day of Week",
      "Some day of month",
      "Twice a month",
    ],
    period: [],
    weeks: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    payments: [],
    Page: 0,
    Searched: "",
    Total: null,
    TotalPages: null,
    payment: {
      name: null,
      grace_days: null,
      day: [],
      notify_days: null,
      type: null,
    },
    valForType: null,
    pages: [10, 50, 100],
    per_page: 10,
    loading: true,
    isShow: false,
    isActive: false,
  }),
  computed: {
    paginationCondition() {
      return this.payments.length < this.per_page && this.Page === 0;
    },
  },
  watch: {
    Searched() {
      this.isShow = false;
      this.Page = 0;
      this.GetList();
    },
    isActive() {
      this.Page = 0;
      this.GetList();
    },
  },
  created() {
    for (var i = 0; i <= 30; i++) {
      this.period.push(i);
    }
    this.GetList();
  },
  methods: {
    changeStatus(id, isActive) {
      const payment = { is_active: !isActive };
      this.$store
        .dispatch("EditPaymentTerm", { payment, id })
        .then(() => {
          this.$success("Payment term status was changed");
          this.GetList();
        })
        .catch((err) => this.$error(err));
    },
    nth(n) {
      return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    changePerPage(e) {
      this.GetList();
    },
    GetList() {
      this.loading = true;
      this.$store
        .dispatch("GetPaymentTerms", {
          page: this.Page,
          search: this.Searched,
          total: this.per_page ? this.per_page : 10,
          is_active: this.isActive,
        })
        .then((res) => {
          this.loading = false;
          if (this.Searched === "" && res.items.length === 0) {
            this.$router.push({ name: "system-admin-add-payment-term" });
            return;
          }
          if (this.Searched !== "" && res.items.length === 0) {
            this.isShow = true;
            return;
          }
          this.payments = res.items.map(this.transformPayments);
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        name: i.name,
        type: i.type,
        graceDays: i.grace_days,
        notifyDays: i.notify_days,
        paymentTermId: i.payment_term_uuid,
        days: i.days,
        usedBy: i.used_by,
        isActive: i.is_active,
      };
    },
    deletePayment(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this payment!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeletePaymentTerm", id)
            .then(() => {
              this.$swal({
                title: "Deleted!",
                text: "The Payment has been deleted.",
                type: "success",
              });
              this.GetList();
            })
            .catch((err) => {
              console.log("err=====>", err.response.data);
              this.$snotify.error(err.response.data.errors[0]);
            });
        }
      });
    },
    addPayment: async function () {
      const valid = await this.$validator.validate();
      if (!valid) {
        return;
      }

      try {
        console.log("this.payment", this.payment);
        await this.$store.dispatch("AddPaymentTerm", {
          payment: this.payment,
        });

        this.$snotify.success("Payment term have been added.", {
          timeout: 6000,
        });

        //this.$router.push({ name: "system-admin-payment-term" });
        this.payment = {
          name: null,
          grace_days: null,
          day: [],
          notify_days: null,
          type: null,
        };
        this.GetList();
      } catch (err) {
        if (err.errors) {
          //   this.contactError = err.errors[0].contact
          //     ? err.errors[0].contact
          //     : null;
          //   setTimeout(() => {
          //     this.contactError = null;
          //   }, 6000);
        } else {
          console.log("err.response.data.errors", err.response.data.errors);
          this.$snotify.error(
            err.response.data.error.message
              ? err.response.data.error.message
              : err.response.data.errors,
            {
              timeout: 6000,
            }
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-container {
  padding: 0 20px;

  .show-active-items {
    display: flex;
    align-items: center;
    // padding: 15px 0;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    label {
      white-space: nowrap;
      margin-bottom: 0;
    }
  }
  .no-data-found {
    padding: 20px;
    text-align: center;
    font-size: 20px;
    color: #e2e5ea;
    background-color: #fff;
  }
  .per-page {
    display: flex;
    align-items: center;

    margin-top: 20px;
  }
  .perPage {
    width: 120px;
  }
  .right-wrapprr {
    width: 100%;
    display: contents;
  }
  .custom-row {
    margin-right: 10px;
  }
  .buttons-wrapper {

    &.pagination {
      width: fit-content;
      flex-grow: 1;
    }
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 15px;
    }
  }

  .add-navigation {
    margin-top: 20px;
    margin-bottom: 20px;
    .search-container {
      margin-bottom: 20px;
      align-items: center;
      .search-input {
        height: 36px;
        max-width: 345px;
        background-color: #ffffff;
      }
    }
    .buttons-wrapper {
      .primary-button {
        height: 40px;
        width: 190px;
      }
    }
  }
}

table.Invoice_table {
  width: 100%;

  th {
    position: relative;
    text-align: center;

    .status {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      cursor: pointer;
      transition: .2s;

      &:hover {
        transition: .2s;
        transform: scale(1.3);
      }

      &.active {
        background-color: #24e2b8;
      }
      &.inactive {
        background-color: #d2305b;
      }
    }
  }
  .action {
    width: 90px;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 25%;
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 12px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  height: 20px;
  color: #212b36;
  font-family: "Helvetica Neue";
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding: 15px 20px;
  min-width: 70px;
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
tr.add_row {
  .select {
    display: flex;
    padding-right: 15px;
    .type {
      width: 180px;
    }
    .valForType {
      width: 120px;
    }
  }
  .input {
    padding-right: 15px;
  }
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 17px;
}
th.img_contaioner {
  padding: 7px 0;
}
th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
th.icon {
  float: right;
  padding: 7px 0;
  height: 44px;
  .svg-grey {
    height: 30px;
    width: 30px;
    cursor: pointer;
    fill: #55616e;
  }
  .delete {
    margin-left: 5px;
    // margin-right: 20px;
  }
}
th.usedBy {
  cursor: pointer;
}
@media (max-width: 1310px) {
  table.Invoice_table {
    width: 1200px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

